@if (!isHandset) {
  <div class="session-page" (window:resize)="onResize($event)">
    <div class="session-titles">
      <div class="session-titles-header">
        <h3>Menu Admin</h3>
        <!-- <button matButton mat-button (click)="showMenu = !showMenu;"><mat-icon>+</mat-icon></button> -->
      </div>
      <div class="session-titles-content" >
        <h5>Dashboard</h5>
        <h6><a routerLink ="/admin/dashboard">Dashboard</a> </h6>
        <mat-divider></mat-divider>
        <h5>Utilisateurs</h5>
        <h6><a routerLink ="/admin/users">Comptes</a></h6>
        <h6><a routerLink ="/admin/contracts">Contrats </a></h6>
        <mat-divider></mat-divider>
        <h5>Référentiel marques</h5>
        <h6><a routerLink ="/admin/carrefs">Modeles Ref </a> </h6>
        <h6><a routerLink ="/admin/cars">Véhicules </a></h6>
        <mat-divider></mat-divider>
        <h5>Services</h5>
        <h6><a routerLink ="/admin/buy">Ventes </a></h6>
        <h6><a routerLink ="/admin/rent">Locations </a> </h6>
        <h6><a routerLink ="/admin/keep">Entretiens </a></h6>
        <mat-divider></mat-divider>
        <h5>Communications</h5>
        <h6><a [routerLink]="['/admin/appointments']">Mes rendez-vous </a></h6>
        <h6><a [routerLink]="['/admin/conversations']">Mes conversations</a></h6>
        <h6><a [routerLink]="['/admin/notifications']">Notifications </a></h6>
        <mat-divider></mat-divider>
        <h5>Compte</h5>
        <h6><a [routerLink]="['/admin/account']">Mon compte</a></h6>
      </div>
    </div>
    <div class="session-content">
      <router-outlet></router-outlet>
      @if ((fetchingResults$ | async)!) {
        <p style="text-align:center">
          <mat-spinner style="margin:0 auto;"  [diameter]="40"></mat-spinner>
        </p>
      }
    </div>
  </div>
}


@if (isHandset) {
  <div class="session-page" (window:resize)="onResize($event)" >
    <mat-drawer-container class="sidenav-container" autosize>
      <mat-drawer #drawer class="sidenav-menu" mode="over" position="end">
        <div class="session-titles-header">
          <h3>Menu Admin &nbsp;&nbsp;&nbsp;</h3>
          <button mat-icon-button (click)="drawer.toggle()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <h5>Dashboard</h5>
        <h6><a routerLink ="/admin/dashboard">Dashboard</a> </h6>
        <mat-divider></mat-divider>
        <h5>Utilisateurs</h5>
        <h6><a routerLink ="/admin/users">Comptes</a></h6>
        <h6><a routerLink ="/admin/contracts">Contrats </a></h6>
        <mat-divider></mat-divider>
        <h5>Référentiel marques</h5>
        <h6><a routerLink ="/admin/carrefs">Modeles Ref </a> </h6>
        <h6><a routerLink ="/admin/cars">Véhicules </a></h6>
        <mat-divider></mat-divider>
        <h5>Services</h5>
        <h6><a routerLink ="/admin/buy">Ventes </a></h6>
        <h6><a routerLink ="/admin/rent">Locations </a> </h6>
        <h6><a routerLink ="/admin/keep">Entretiens </a></h6>
        <mat-divider></mat-divider>
        <h5>Communications</h5>
        <h6><a [routerLink]="['/admin/appointments']">Mes rendez-vous </a></h6>
        <h6><a [routerLink]="['/admin/conversations']">Mes conversations</a></h6>
        <h6><a [routerLink]="['/admin/notifications']">Notifications </a></h6>
        <mat-divider></mat-divider>
        <h5>Compte</h5>
        <h6><a [routerLink]="['/admin/account']">Mon compte</a></h6>
        <!-- <h6><a [routerLink]="['/provider/public']" [queryParams]="{id: currentUserId}">Mon profil public </a></h6> -->
      </mat-drawer>
      <div class="sidenav-page">
        <div class="session-top">
          <h3>Menu Admin &nbsp;&nbsp;&nbsp;</h3>
          <button mat-icon-button (click)="drawer.toggle()">
            <mat-icon>menu</mat-icon>
          </button>
        </div>
        <div class="session-content">
          <router-outlet></router-outlet>
          @if ((fetchingResults$ | async)!) {
            <p style="text-align:center">
              <mat-spinner style="margin:0 auto;"  [diameter]="40"></mat-spinner>
            </p>
          }
        </div>
      </div>
    </mat-drawer-container>
  </div>
}



@if (false) {
  <div class="session-page">
    <div class="session-titles" >
      <h3>Menu Admin</h3>
      <h5>Dashboard</h5>
      <h6><a routerLink ="/admin/dashboard">Dashboard</a> </h6>
      <mat-divider></mat-divider>
      <h5>Utilisateurs</h5>
      <h6><a routerLink ="/admin/users">Comptes</a></h6>
      <h6><a routerLink ="/admin/contracts">Contrats </a></h6>
      <mat-divider></mat-divider>
      <h5>Référentiel marques</h5>
      <h6><a routerLink ="/admin/carrefs">Modeles Ref </a> </h6>
      <h6><a routerLink ="/admin/cars">Véhicules </a></h6>
      <mat-divider></mat-divider>
      <h5>Services</h5>
      <h6><a routerLink ="/admin/buy">Ventes </a></h6>
      <h6><a routerLink ="/admin/rent">Locations </a> </h6>
      <h6><a routerLink ="/admin/keep">Entretiens </a></h6>
      <mat-divider></mat-divider>
      <h5>Communications</h5>
      <h6><a [routerLink]="['/admin/appointments']">Mes rendez-vous </a></h6>
      <h6><a [routerLink]="['/admin/conversations']">Mes conversations</a></h6>
      <h6><a [routerLink]="['/admin/notifications']">Notifications </a></h6>
      <mat-divider></mat-divider>
      <h5>Compte</h5>
      <h6><a [routerLink]="['/admin/account']">Mon compte</a></h6>
    </div>
    <div class="session-content">
      <router-outlet></router-outlet>
    </div>
  </div>
}
